// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9634c395","453":"f88ae08e"}[chunkId] + ".chunk.js";
};